/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { DataTable } from '@scuf/datatable';
import { Checkbox, Icon, List } from '@scuf/common';
import _ from 'lodash';
import { ConfigurationContext } from '../pages/common/ConfigurationContext';
import APIClient from '../common/APIClient';

class FeatureAccessTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFeatureRows: [],
      featureList: [],
    };
  }

  componentDidMount() {
    const { fetchFeatureData } = this.context;
    this.fetchFeatureList();
    fetchFeatureData();
  }

  // FeatureAccessTable
  // fetch all available features to form list of checkboxes
  fetchFeatureList = async () => {
    const { appContext } = this.context;
    const featureList = await APIClient.getFeatureList(appContext.user);
    this.setState({ featureList: featureList.response });
  };

  render() {
    const { selectedFeatureRows, featureList } = this.state;
    const { featureData, updateContextState } = this.context;
    return (
      <DataTable
        data={featureData}
        selection={selectedFeatureRows}
        selectionMode="multiple"
        onSelectionChange={(e) => {
          this.setState({ selectedFeatureRows: e });
        }}
        onEdit={(newData, cellData) => {
          featureData[cellData.rowIndex][cellData.field] = newData;
          updateContextState('featureData', featureData);
        }}
      >
        <DataTable.HeaderBar>
          <DataTable.HeaderBar.Item
            content="Add"
            icon={<Icon name="slidercontrols-plus" size="small" root="common" />}
            onClick={() => {
              const newEntry = { emailDomain: '', features: [] };
              if (!featureData.some((item) => item.emailDomain === newEntry.emailDomain)) {
                const newFeatureData = [...featureData, newEntry];
                updateContextState('featureData', newFeatureData);
              }
            }}
          />
          <DataTable.HeaderBar.Item
            content="Delete"
            icon={<Icon name="delete" size="small" root="common" />}
            disabled={selectedFeatureRows.length === 0}
            onClick={() => {
              const newFeatureData = _.differenceWith(featureData, selectedFeatureRows, _.isEqual);
              // rows with an ID field -> exists in mongo; need to delete in mongo
              // otherwise they were both added and removed since initial fetch
              const toDeleteRows = selectedFeatureRows.filter((row) => row.id);
              this.setState({ selectedFeatureRows: [] });
              updateContextState('removedFeatureRows', toDeleteRows);
              updateContextState('featureData', newFeatureData);
            }}
          />
        </DataTable.HeaderBar>
        <DataTable.Column
          field="emailDomain"
          header="Email Domain"
          editable
          placeholder="Enter domain..."
        />
        <DataTable.Column
          field=""
          header="Features"
          placeholder="Select features"
          renderer={(cellData) => {
            return (
              <List selection>
                {featureList.map((feature) => {
                  return (
                    <List.Content key={feature.featureId} className="feature-list-content">
                      <Checkbox
                        label={feature.displayText}
                        checked={cellData.rowData.features.some(
                          (e) => e.featureId === feature.featureId
                        )}
                        onChange={(checked) => {
                          const newFeatureData = [...featureData];
                          if (checked) {
                            newFeatureData.find((o, i) => {
                              if (o.emailDomain === cellData.rowData.emailDomain) {
                                newFeatureData[i].features.push(feature);
                                return true;
                              }
                              return false;
                            });
                          } else {
                            newFeatureData.find((o, i) => {
                              if (o.emailDomain === cellData.rowData.emailDomain) {
                                _.remove(newFeatureData[i].features, (n) => {
                                  return n.featureId === feature.featureId;
                                });
                                return true;
                              }
                              return false;
                            });
                          }
                          updateContextState('featureData', newFeatureData);
                        }}
                      />
                    </List.Content>
                  );
                })}
              </List>
            );
          }}
        />
      </DataTable>
    );
  }
}

FeatureAccessTable.contextType = ConfigurationContext;

export default FeatureAccessTable;
